import type { IFontPreset, TView, TTitleView, TParagraphView, TFontWeightValid } from '../models';

import { buildFontPreset } from './build-font-preset';

const titleViews: Record<TTitleView, IFontPreset> = {
    xlarge: buildFontPreset(48, 52, 700),
    large: buildFontPreset(40, 48, 700),
    medium: buildFontPreset(30, 36, 700),
    small: buildFontPreset(22, 26, 700),
    xsmall: buildFontPreset(18, 22, 700),
};

const paragraphViews: Record<TParagraphView, IFontPreset> = {
    'primary-large': buildFontPreset(18, 24, 400),
    'primary-medium': buildFontPreset(16, 24, 400),
    'primary-small': buildFontPreset(14, 20, 400),
    'secondary-large': buildFontPreset(13, 16, 400),
    'secondary-medium': buildFontPreset(12, 16, 400),
    'secondary-small': buildFontPreset(11, 16, 400),
    'component-primary': buildFontPreset(16, 20, 400),
    'component-secondary': buildFontPreset(14, 18, 400),
    caps: buildFontPreset(12, 16, 500, 'uppercase', 125),
    tagline: buildFontPreset(12, 16, 400, 'uppercase', 125),
};

const actualParagraphKeys = Object.entries(paragraphViews) as Array<[TParagraphView, IFontPreset]>;

const buildAdditionalViews = <T extends string>(prefix: T, fontWeight: TFontWeightValid) =>
    actualParagraphKeys.reduce((acc, [paragraphViewKey, paragraphViewPreset]) => {
        return {
            ...acc,
            [`${prefix}-${paragraphViewKey}`]: buildFontPreset(
                paragraphViewPreset.fontSize,
                paragraphViewPreset.lineHeight,
                fontWeight,
                paragraphViewPreset.textTransform,
                paragraphViewPreset.letterSpacing
            ),
        };
    }, {} as Record<`${T}-${TParagraphView}`, IFontPreset>);

export const fontViews: Record<TView, IFontPreset> = {
    ...titleViews,
    ...paragraphViews,
    ...buildAdditionalViews('accent', 700),
    ...buildAdditionalViews('action', 500),
    /** @deprecated используйте component-primary */
    component: buildFontPreset(16, 20, 400),
};
